// extracted by mini-css-extract-plugin
module.exports = {"block":"EventSelector_block__35WLI","name":"EventSelector_name__3wUhw","item":"EventSelector_item__926IN"};